import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import useImpersonation from "../hooks/impersonation";

const ImpersonationBanner = () => {
  const { isImpersonating, endImpersonation } = useImpersonation();
  const userData = JSON.parse(localStorage.getItem("user_data") || "null");

  if (!isImpersonating || !userData) return null;

  return (
    <Box sx={{ backgroundColor: "#EE295D", color: "#fff", px: 2, py: 1 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2">
          Viewing as <b>{userData.full_name}</b> ({userData.role}) — Read Only
        </Typography>
        <Button
          size="small"
          variant="outlined"
          sx={{ color: "#fff", borderColor: "#fff" }}
          onClick={endImpersonation}
        >
          Exit
        </Button>
      </Stack>
    </Box>
  );
};

export default ImpersonationBanner;
